import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUserCircle, faHistory, faTable, faStore } from '@fortawesome/free-solid-svg-icons'
import { faCompass, faCheckCircle } from '@fortawesome/free-regular-svg-icons'

import "../App.css"

export const ERROR_TOAST_DUSATION = 2000;

export const toGetComp = (formID) => {

    switch (formID) {
        case 'formecomm':
            return {
                constants: [{
                    'id': 'user',
                    'title': 'User View',
                    'position': 1
                },
                {
                    'id': 'ecomcust',
                    'title': 'Active Customers',
                    'position': 2
                },
                {
                    'id': 'request-status',
                    'title': 'Request Status',
                    'position': 6
                },
                ],
                admin: [
                {
                    'id': 'consolidated',
                    'title': 'Consolidated',
                    'position': 4
                },
                {
                    'id': 'approval',
                    'title': 'Approval',
                    'position': 5
                },
                {
                    'id': 'ecomcustadmin',
                    'title': 'Active Customers - Approval',
                    'position': 3
                },
                {
                    'id': 'categoryBrandMapping',
                    'title': 'Category Brand Mapping',
                    'position': 7
                },
                {
                    'id': 'eretailbp',
                    'title': 'BP Targets Setup',
                    'position': 8
                }
            
            ]
            }

            break;

        case 'emission':
            return {
                constants: [{
                    'id': 'user',
                    'title': '2017 BaseLine Target',
                    'position': 1
                },
                {
                    'id': 'emission_2030_targets',
                    'title': '2030 Roadmap Target',
                    'position': 2
                }
                ],
                admin: []
            }

            break;

        case 'formsku':
            return {
                constants: [{
                    'id': 'user',
                    'title': 'Exclusion List for CRI Calculation',
                    'position': 1
                },
                {
                    'id': 'consolidated',
                    'title': 'New launches and Delisting - YTD actual',
                    'position': 2
                },
                {
                    'id': 'approval',
                    'title': 'STM',
                    'position': 3
                }],
                admin: []
            }

            break;

         case 'formskuByCountry':
            return {
                constants: [{
                    'id': 'ExclusionList',
                    'title': 'Exclusion List for CRI Calculation',
                    'position': 1
                },
                {
                    'id': 'NewLaunches',
                    'title': 'New launches and Delisting - YTD actual',
                    'position': 2
                },
                {
                    'id': 'STM',
                    'title': 'STM',
                    'position': 3
                }],
                 admin: []
            }

            break;    

        case 'formmap':
            return {
                constants: [{
                    'id': 'user',
                    'title': 'Brand',
                    'position': 1
                }, {
                    'id': 'consolidated',
                    'title': 'Channel',
                    'position': 2
                },
                {
                    'id': 'approval',
                    'title': 'Package',
                    'position': 3
                },
                {
                    'id': 'request-status',
                    'title': 'Company',
                    'position': 4
                },
                {
                    'id': 'ikamap',
                    'title': 'IKA Mapping',
                    'position': 5
                },
                {
                    'id': 'ccm',
                    'title': 'Cost Categories Mapping',
                    'position': 6
                }],
                admin: []
            }

            break;
        case 'custhier':
            return {
                constants: [{
                    'id': 'user',
                    'title': 'Custom Hierarchy',
                    'position': 1
                }
                ],
                admin: []
            }

            break;

        case 'manualnum':
            return {
                constants: [{
                    'id': 'user',
                    'title': 'Manual Adjustment Best Estimates',
                    'position': 1
                }
                ],
                admin: []
            }

            break;
            case 'priceforecast':
                return {
                    constants: [{
                        'id': 'user',
                        'title': 'Price Forecast',
                        'position': 1
                    },
                    ],
                    admin: []
                }
    
                break;
        default:
            return {
                constants: [{
                    'id': 'user',
                    'title': 'User View'
                }],
                admin: []
            }
    }
}

export const getNavLinkIcon = (navLink) => {
    switch (navLink) {
        case "eretailbp":
            return <FontAwesomeIcon icon={faTable} className="navlink-icon" size="2x" />;
        case 'ExclusionList':
        case 'user':
            return <FontAwesomeIcon icon={faUserCircle} className="navlink-icon" size="2x" />;
        case 'request-status':
            return <FontAwesomeIcon icon={faHistory} className="navlink-icon" size="2x" />;
        case 'emission_2030_targets':
            return <FontAwesomeIcon icon={faUserCircle} className="navlink-icon" size="2x" />;
        case 'NewLaunches':
        case 'consolidated':
            return <FontAwesomeIcon icon={faCompass} className="navlink-icon" size="2x" />;
        case 'STM':
        case 'approval':
        case 'ecomcustadmin':
            return <FontAwesomeIcon icon={faCheckCircle} className="navlink-icon" size="2x" />;
        case 'categoryBrandMapping':
            return <FontAwesomeIcon icon={faUserCircle} className="navlink-icon" size="2x" />;
            break;
        case 'ikamap':
        case 'ccm':
            return <FontAwesomeIcon icon={faUserCircle} className="navlink-icon" size="2x" />;
        case 'ecomcust':
            return <FontAwesomeIcon icon={faStore} className="navlink-icon" size="2x" />;
        default:
            return;
    }
}

export const getExternalLink = (form_id) => {
    switch (form_id) {
        case 'formecomm':
            // return "https://app.powerbi.com/groups/fbc5e91b-ce10-4bf6-b96b-545075dd243e/reports/f759d780-8677-451c-a5a5-575af6c9b8c5/ReportSection0e317ddce06e7edc0002?ctid=7a67a070-8ce9-4692-b1af-bf788306bc66";
            return {
                'link': process.env.REACT_APP_EXTERNAL_LINK_ECOMM,
                'title': 'eRetail & FSA'
            }
            break;

        case 'formskuByCountry':
            // return "https://app.powerbi.com/groups/24b87e87-f100-4744-b1e9-df9773014e55/reports/4a438683-b7d9-430f-bb28-be25d6728eed/ReportSectionaa7792ef7edfb873cb8b?ctid=7a67a070-8ce9-4692-b1af-bf788306bc66%22;
            return {
                'link': process.env.REACT_APP_EXTERNAL_LINK_SKU_BY_COUNTRY,
                'title': 'SKU Performance 3.0'
            }
            break;
        case 'formsku':
            // return "https://app.powerbi.com/groups/24b87e87-f100-4744-b1e9-df9773014e55/reports/4a438683-b7d9-430f-bb28-be25d6728eed/ReportSectionaa7792ef7edfb873cb8b?ctid=7a67a070-8ce9-4692-b1af-bf788306bc66";
            return {
                'link': process.env.REACT_APP_EXTERNAL_LINK_SKU,
                'title': 'SKU Performance'
            }
            break;
        case 'formmap':
            // return "https://app.powerbi.com/groups/24b87e87-f100-4744-b1e9-df9773014e55/reports/4a438683-b7d9-430f-bb28-be25d6728eed/ReportSectionaa7792ef7edfb873cb8b?ctid=7a67a070-8ce9-4692-b1af-bf788306bc66";
            return {
                'link': process.env.REACT_APP_EXTERNAL_LINK_MFA,
                'title': 'CCH-The Edge'
            }
            break;
        case 'manualnum':
            // return "https://app.powerbi.com/groups/24b87e87-f100-4744-b1e9-df9773014e55/reports/4a438683-b7d9-430f-bb28-be25d6728eed/ReportSectionaa7792ef7edfb873cb8b?ctid=7a67a070-8ce9-4692-b1af-bf788306bc66";
            return {
                'link': process.env.REACT_APP_EXTERNAL_LINK_MFA,
                'title': 'Manual Adjustment Best Estimates'
            }
            break;
        case 'priceforecast':
            // return "https://app.powerbi.com/groups/24b87e87-f100-4744-b1e9-df9773014e55/reports/4a438683-b7d9-430f-bb28-be25d6728eed/ReportSectionaa7792ef7edfb873cb8b?ctid=7a67a070-8ce9-4692-b1af-bf788306bc66";
            return {
                'link': process.env.REACT_APP_EXTERNAL_LINK_MFA,
                'title': 'Price Forecast'
            }
            break;
        case 'custhier':
            // return "https://app.powerbi.com/groups/24b87e87-f100-4744-b1e9-df9773014e55/reports/4a438683-b7d9-430f-bb28-be25d6728eed/ReportSectionaa7792ef7edfb873cb8b?ctid=7a67a070-8ce9-4692-b1af-bf788306bc66";
            return {}
            break;
        default:
            return {
                'link': process.env.REACT_APP_EXTERNAL_LINK_MFA,
                'title': 'eRetail & FSA'
            }
            break;
    }
}

export const getInfoDetails = (form_id) => {
    switch (form_id) {
        case 'formecomm':
            return {
                'enable': false,
                'description': "Description",
                'title': 'eRetail & FSA'
            }
            break;
        case 'formsku':
            return {
                'enable': true,
                'description': "Description",
                'title': 'SKU Performance'
            }
            break;
        case 'formmap':
            return {
                'enable': true,
                'description': "Description",
                'title': 'CCH-The Edge'
            }
            break;
        case 'custhier':
            return {
                'enable': true,
                'description': "Description",
                'title': ''
            }
            break;
        default:
            return {
                'enable': false,
                'description': "Description",
                'title': 'Title'
            }
            break;
    }
}

export const channelCategoryInitailColumnsForm = [
    {
        id: 'bic_ccusthie4',
        label: 'Bic ccusthie4',
        minWidth: 200,
        align: 'right',
        group: "channel_category"
    },
    {
        id: 'home_ooh',
        label: 'Home ooh',
        minWidth: 150,
        align: 'right',
        group: "channel_category"
    },
    {
        id: 'trade_channel_ch3',
        label: 'Trade Channel ch3',
        minWidth: 200,
        align: 'right',
        group: "channel_category"
    },
    {
        id: 'subtrade_channel_ch4',
        label: 'Subtrade Channel ch4',
        minWidth: 200,
        align: 'right',
        group: "channel_category"
    },
    {
        id: 'channel_vr',
        label: 'Channel vr',
        minWidth: 130,
        align: 'right',
        group: "channel_category"
    },
    {
        id: 'added_by',
        label: 'Added By',
        minWidth: 235,
        align: 'right',
        group: "other"
    },
    {
        id: 'updated_by',
        label: 'Updated By',
        minWidth: 235,
        align: 'right',
        group: "channel_category"
    },
    {
        id: 'updated_at',
        label: 'Updated At',
        minWidth: 235,
        align: 'right',
        group: "channel_category"
    },
    {
        id: 'action',
        label: '',
        minWidth: 50,
        align: 'right',
        group: "other"
    },
];

export const packageInitailColumnsForm = [
    {
        id: 'package_size',
        label: 'Package Size',
        minWidth: 150,
        align: 'right',
        group: "package_mapping"
    },
    {
        id: 'package_type',
        label: 'Package Type',
        minWidth: 200,
        align: 'right',
        group: "package_mapping"
    },
    {
        id: 'package_key',
        label: 'Package Key',
        minWidth: 200,
        align: 'right',
        group: "package_mapping"
    },
    {
        id: 'final_package',
        label: 'Final Package',
        minWidth: 130,
        align: 'right',
        group: "package_mapping"
    },
    {
        id: 'reported_pack',
        label: 'Reported Package',
        minWidth: 150,
        align: 'right',
        group: "package_mapping"
    },
    {
        id: 'pack_type_1',
        label: 'PackType 1',
        minWidth: 200,
        align: 'right',
        group: "package_mapping"
    },
    {
        id: 'pack_type_2',
        label: 'PackType 2',
        minWidth: 150,
        align: 'right',
        group: "package_mapping"
    },
    {
        id: 'rank',
        label: 'Rank',
        minWidth: 150,
        align: 'right',
        group: "channel_category"
    },
    {
        id: 'added_by',
        label: 'Added By',
        minWidth: 235,
        align: 'right',
        group: "other"
    },
    {
        id: 'updated_by',
        label: 'Updated By',
        minWidth: 235,
        align: 'right',
        group: "channel_category"
    },
    {
        id: 'updated_at',
        label: 'Updated At',
        minWidth: 235,
        align: 'right',
        group: "channel_category"
    },
    {
        id: 'action',
        label: '',
        minWidth: 50,
        align: 'right',
        group: "other"
    },
];

export const dimCompanyInitailColumnsForm = [
    {
        id: 'region_sequence_id',
        label: 'Region Seq ID',
        minWidth: 150,
        align: 'right',
        group: ""
    },
    {
        id: 'region',
        label: 'Region',
        minWidth: 200,
        align: 'right',
        group: ""
    },
    {
        id: 'market_segment',
        label: 'Market Segment',
        minWidth: 200,
        align: 'right',
        group: ""
    },
    {
        id: 'business_unit',
        label: 'Business Unit',
        minWidth: 130,
        align: 'right',
        group: ""
    },
    {
        id: 'business_unit_abbreviation',
        label: 'Business Unit Abbr',
        minWidth: 150,
        align: 'right',
        group: ""
    },
    {
        id: 'country',
        label: 'Country',
        minWidth: 150,
        align: 'right',
        group: ""
    },
    {
        id: 'country_p_c',
        label: 'Country P&C',
        minWidth: 150,
        align: 'right',
        group: ""
    },
    {
        id: 'country_abbreviation',
        label: 'Country Abbr',
        minWidth: 100,
        align: 'right',
        group: ""
    },
    {
        id: 'geo_country',
        label: 'Geo Country',
        minWidth: 150,
        align: 'right',
        group: ""
    },
    {
        id: 'geo_country_abbreviation',
        label: 'Geo Country Abbr',
        minWidth: 150,
        align: 'right',
        group: ""
    },
    {
        id: 'co_code_bw',
        label: 'CO Code BW',
        minWidth: 150,
        align: 'right',
        group: ""
    },
    {
        id: 'country_sequence_id',
        label: 'Country Seq ID',
        minWidth: 150,
        align: 'right',
        group: ""
    },
    {
        id: 'business_unit_sequence_id',
        label: 'Business Unit Seq ID',
        minWidth: 150,
        align: 'right',
        group: ""
    },
    {
        id: 'added_by',
        label: 'Added By',
        minWidth: 235,
        align: 'right',
        group: "other"
    },
    {
        id: 'updated_by',
        label: 'Updated By',
        minWidth: 235,
        align: 'right',
        group: "channel_category"
    },
    {
        id: 'updated_at',
        label: 'Updated At',
        minWidth: 235,
        align: 'right',
        group: "channel_category"
    },
    {
        id: 'action',
        label: '',
        minWidth: 50,
        align: 'right',
        group: "other"
    },
];

export const skuExclusionNewlistAndDelistInitialColumnsForm = [
    {
        id: 'quarter',
        label: 'Quarter',
        minWidth: 100,
        align: 'right',
        group: "channel_category"
    },
    {
        id: 'business_unit_name',
        label: 'Business Unit',
        minWidth: 150,
        align: 'right',
        group: "channel_category"
    },
    {
        id: 'type_title',
        label: 'Type',
        minWidth: 100,
        align: 'right',
        group: "channel_category"
    },
    {
        id: 'item_category',
        label: 'Item Category',
        minWidth: 130,
        align: 'right',
        group: "channel_category"
    },
    {
        id: 'ban_description',
        label: 'BAN Description',
        minWidth: 300,
        align: 'right',
        group: "other"
    },
    {
        id: 'ban_number',
        label: 'BAN Number',
        minWidth: 200,
        maxWidth: 200,
        align: 'center',
        is_sortable: true,
        is_sorted: false,
        sort_type: "asc",
        sort_name: "ban_number"
    },
    {
        id: 'category_title',
        label: 'Category',
        minWidth: 150,
        align: 'right',
        group: "other"
    },
    {
        id: 'new_quarter',
        label: 'Quarter(Newlist/Delist)',
        minWidth: 100,
        align: 'right',
        group: "channel_category"
    },
    {
        id: 'action',
        label: '',
        minWidth: 50,
        align: 'right',
        group: "other"
        // format: (value) => value.toFixed(2),
    },
];

export const skuExclusionNewlistAndDelistByCountryInitialColumnsForm = [
    {
        id: 'quarter',
        label: 'Quarter',
        minWidth: 100,
        align: 'right',
        group: "channel_category"
    },
    {
        id: 'country_name',
        label: 'Country',
        minWidth: 150,
        align: 'right',
        group: "channel_category"
    },
    {
        id: 'type_title',
        label: 'Type',
        minWidth: 100,
        align: 'right',
        group: "channel_category"
    },
    {
        id: 'item_category',
        label: 'Item Category',
        minWidth: 130,
        align: 'right',
        group: "channel_category"
    },
    {
        id: 'ban_description',
        label: 'BAN Description',
        minWidth: 300,
        align: 'right',
        group: "other"
    },
    {
        id: 'ban_number',
        label: 'BAN Number',
        minWidth: 200,
        maxWidth: 200,
        align: 'center',
        is_sortable: true,
        is_sorted: false,
        sort_type: "asc",
        sort_name: "ban_number"
    },
    {
        id: 'category_title',
        label: 'Category',
        minWidth: 150,
        align: 'right',
        group: "other"
    },
    {
        id: 'new_quarter',
        label: 'Quarter(Newlist/Delist)',
        minWidth: 100,
        align: 'right',
        group: "channel_category"
    },
    {
        id: 'action',
        label: '',
        minWidth: 50,
        align: 'right',
        group: "other"
        // format: (value) => value.toFixed(2),
    },
];

export const skuSTMInitialColumnsForm = [
    {
        id: 'quarter',
        label: 'Quarter',
        minWidth: 100,
        align: 'right',
        group: "channel_category"
    },
    {
        id: 'business_unit_name',
        label: 'Business Unit',
        minWidth: 150,
        align: 'right',
        group: "channel_category"
    },
    {
        id: 'project_description',
        label: 'Project Description',
        minWidth: 250,
        align: 'right',
        group: "channel_category"
    },
    {
        id: 'actual_launch_date',
        label: 'Actual Launch Date',
        minWidth: 100,
        align: 'right',
        group: "channel_category"
    },
    {
        id: 'is_on_time',
        label: 'On Time',
        minWidth: 100,
        align: 'right',
        group: "other"
    },
    {
        id: 'delay_reason',
        label: 'Delay Reason',
        minWidth: 200,
        align: 'right',
        group: "other"
    },
    {
        id: 'project_duration',
        label: 'Project Duration(In Weeks)',
        minWidth: 150,
        align: 'right',
        group: "other"
    },
    {
        id: 'action',
        label: '',
        minWidth: 50,
        align: 'right',
        group: "other"
    },
    ];

export const skuSTMInitialColumnsByCountryForm = [
    {
        id: 'quarter',
        label: 'Quarter',
        minWidth: 100,
        align: 'right',
        group: "channel_category"
    },
    {
        id: 'country_name',
        label: 'Country',
        minWidth: 150,
        align: 'right',
        group: "channel_category"
    },
    {
        id: 'project_description',
        label: 'Project Description',
        minWidth: 250,
        align: 'right',
        group: "channel_category"
    },
    {
        id: 'actual_launch_date',
        label: 'Actual Launch Date',
        minWidth: 100,
        align: 'right',
        group: "channel_category"
    },
    {
        id: 'is_on_time',
        label: 'On Time',
        minWidth: 100,
        align: 'right',
        group: "other"
    },
    {
        id: 'delay_reason',
        label: 'Delay Reason',
        minWidth: 200,
        align: 'right',
        group: "other"
    },
    {
        id: 'project_duration',
        label: 'Project Duration(In Weeks)',
        minWidth: 150,
        align: 'right',
        group: "other"
    },
    {
        id: 'action',
        label: '',
        minWidth: 50,
        align: 'right',
        group: "other"
    },
];